import { SectionSubPage } from "@/components/ui/admin/SectionSubPage";
import { useTranslations } from "@/lib/useTranslations";

export function PlacesRedactionPage() {
  const t = useTranslations("places.redaction");
  return (
    <SectionSubPage
      eyebrow={t("eyebrow")}
      title={t("title")}
      description={t("description")}
    />
  );
}

export function PlacesStatisticsPage() {
  const t = useTranslations("places.statistics");
  return (
    <SectionSubPage
      eyebrow={t("eyebrow")}
      title={t("title")}
      description={t("description")}
    />
  );
}
